<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="'Publish to all major app stores from one platform'"
    [icon]="'@tui.store'"
    [subtitle]="'Store Destinations'"
    [title]="'Support for all major platforms'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-2">
    @for (destination of destinations; track destination.name) {
      <div
        class="flex flex-col gap-6 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
      >
        <div class="flex flex-row items-center gap-3">
          <tui-icon [icon]="destination.icon" class="text-2xl" />
          <h3 class="text-xl font-bold md:text-2xl">{{ destination.name }}</h3>
        </div>
        <ul class="flex flex-col gap-3">
          @for (feature of destination.features; track feature) {
            <li class="flex items-center gap-2">
              <tui-icon icon="@tui.check" class="text-green-600" />
              <span class="text-lg">{{ feature }}</span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</section>
